import './LegalPages.css'

export function PcrsResponsibilityStatement() {
  return (
    <main className="legal-page">
      <article className="legal-content">
        <header className="legal-header">
          <h1>PCRS Responsibility Statement</h1>
          <p className="legal-meta">Version 1.0 | Effective date: 2026-02-23</p>
        </header>

        <p className="legal-warning">
          Draft for solicitor review. Final enforceability language should be approved before production use.
        </p>

        <section className="legal-section">
          <h2>1. Customer Control of PCRS Activity</h2>
          <p>
            The practice or clinic is fully responsible for all PCRS-related activity performed through PPT
            or PMS workflows, including data entry, coding selections, declarations, approvals, and
            submissions.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Verification and Compliance Duties</h2>
          <p>
            The customer must verify all claim content before submission and ensure compliance with
            applicable PCRS requirements, reimbursement criteria, and record-keeping obligations.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Liability Allocation</h2>
          <p>
            The customer accepts full liability for PCRS outcomes, including claim acceptance or rejection,
            reimbursement disputes, audits, recoupment, overpayment recovery, penalties, and any related
            losses affecting the practice or clinic.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Indemnity to Clnicl</h2>
          <p>
            The customer agrees to indemnify and hold harmless Clnicl from claims, damages, liabilities, and
            costs arising from PCRS-related actions taken by the customer or its authorised users.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Relationship to Main Terms</h2>
          <p>
            This statement supplements the Terms and Conditions and must be accepted during registration.
            Where there is conflict, the main contract and solicitor-approved order of precedence controls.
          </p>
        </section>

        <nav className="legal-nav" aria-label="Legal navigation">
          <a href="/terms-and-conditions">Terms and Conditions</a>
          <a href="/privacy-notice">Privacy Notice</a>
          <a href="/register">Back to registration</a>
        </nav>
      </article>
    </main>
  )
}
